module.exports = __webpack_public_path__ + "img/Spinner.ff83ae87.svg";